import Link from 'next/link'
import NavBar from '~~/src/components/Main/NavBar'
import { NextSeo } from 'next-seo'

export const style = {
  wrapper: `darkThemeBg h-screen flex flex-col w-[100hw]`,
}

function NotFound() {
  return (
    <div className={style.wrapper}>
      <NextSeo
        title='404 | Deepcity Digital asset Marketplace'
        description='Page not found'
        canonical='https://deepcity.io/404'
        noindex={true}
        nofollow={true}
      />
      <NavBar />
      <div className="grid justify-center content-center px-10 pt-40">
        <h1 className="text-3xl font-semibold text-slate-800 dark:text-slate-200">
          Oooops...
        </h1>
        <h2 className="text-xl font-semibold text-slate-800 dark:text-slate-200">
          404 This page cannot be found.
        </h2>
        <p className="text-lg font-normal text-slate-800 dark:text-slate-200">
          Go back to the home page{' '}
          <Link href={'/'} className="text-blue-600">
            Homepage
          </Link>
        </p>
      </div>
    </div>
  )
}

export default NotFound
